import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  alertTutorcloudOpenError,
  openTutorcloudDestination,
  resolveTutorcloudBillingUrl,
} from "../utils/tutorcloudTeacherLinks";
import { TEMA_ROUTE_PATHS } from "./temaRouteConstants";
import { navigateToRoute } from "./navigateToRoute";

const FALLBACK_COPY = {
  "not-found": {
    title: "Page not found",
    description:
      "The workspace route you requested does not exist or may have moved.",
    actionLabel: "Back to dashboard",
  },
  unauthorized: {
    title: "Access denied",
    description: "You do not have permission to open this iTEMA workspace.",
    actionLabel: "Back to dashboard",
  },
  "auth-required": {
    title: "Sign in required",
    description: "Sign in to access iTEMA workspace routes.",
    actionLabel: "Back to dashboard",
  },
  "subscription-inactive": {
    title: "Plan not active",
    description:
      "Your iTEMA plan is not active. Open Billing & Subscriptions to renew or choose a plan.",
    actionLabel: "Go to billing",
    redirectToTutorcloudBilling: true,
  },
};

export function RouteFallback({ kind = "not-found", routeLabel, hash }) {
  const { canOpenTutorCloud, tcBillingUrl } = useAuth();
  const [openingBilling, setOpeningBilling] = useState(false);
  const copy = FALLBACK_COPY[kind] ?? FALLBACK_COPY["not-found"];

  const detail =
    kind === "not-found" && hash
      ? `Could not resolve route "${hash}".`
      : routeLabel
        ? `"${routeLabel}" is not available for your account.`
        : copy.description;

  return (
    <div className="mx-auto flex min-h-[420px] w-full max-w-[1077px] flex-col items-start justify-center gap-4 px-4 py-10">
      <div
        className="w-full rounded-xl border border-[#e5e7eb] bg-white p-8 shadow-[0px_1px_1.5px_rgba(0,0,0,0.1)]"
        role="alert"
      >
        <h1 className="text-2xl font-bold text-[#111827]">{copy.title}</h1>
        <p className="mt-2 text-sm text-text-secondary">{detail}</p>
        <button
          type="button"
          disabled={openingBilling}
          className="mt-6 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-wait disabled:opacity-70"
          onClick={() => {
            if (copy.redirectToTutorcloudBilling) {
              if (openingBilling) {
                return;
              }
              setOpeningBilling(true);
              openTutorcloudDestination({
                path: resolveTutorcloudBillingUrl(tcBillingUrl),
                allowLaunch: Boolean(canOpenTutorCloud),
              })
                .catch((error) => {
                  alertTutorcloudOpenError(error);
                })
                .finally(() => {
                  setOpeningBilling(false);
                });
              return;
            }
            navigateToRoute(copy.actionPath ?? TEMA_ROUTE_PATHS.DASHBOARD);
          }}
        >
          {openingBilling ? "Opening…" : copy.actionLabel}
        </button>
      </div>
    </div>
  );
}
